export default {
	getStats(state) {
		return state.userStats
	}
};
